import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/spring-sale/ClientPage.tsx");
